import React, { useRef, useState, useEffect, useContext } from "react";
import { useDispatch, useSelector } from "react-redux";
import { welcomeTask } from "./StageSlice";
import { tasksList, tasksListDetails, tasksDetails } from "./TaskSlice";

import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import { Toast } from "primereact/toast";
import { RadioButton } from "primereact/radiobutton";
import { InputTextarea } from "primereact/inputtextarea";
import { getNhtpLinkDetails, Nhtp } from "../Tasks/getNHTPSlice";
import { Checkbox } from "primereact/checkbox";

import {
  managerListDetails,
  moodMeter,
  moodMeterDetails,
} from "./MoodMeterSlice";
import jwt_decode from "jwt-decode";

import "./task.scss";
import { empProfileDetails } from "../Profile/ProfileSlice";
import { isTokenExpired } from "../../../../utils/msal-utils";
import AuthContext from "../../shared-components/authContext";
import { faqListDetails, moodMeterFAQ } from "../getMoodMeterFAQSlice";
import { Accordion, AccordionTab } from "primereact/accordion";
import { openNewAppWithStorage } from "../../../../utils/openNewApp";

const SURVEY_WINDOWS: Record<string, number> = {
  Training_Survey_Midpoint: 120,
  Training_Survey_Endpoint: 168,
};

const getSurveyEffectiveStatus = (rowData: any) => {
  const windowHours = SURVEY_WINDOWS[rowData.step_name_uid];
  if (!windowHours) return rowData.STATUS;
  if (rowData.STATUS === "Completed") return "COMPLETED";
  if (!rowData.sched_date) return "PENDING";
  const sentAt = new Date(rowData.sched_date);
  if (sentAt > new Date()) return "PENDING";
  const expiresAt = new Date(sentAt.getTime() + windowHours * 3_600_000);
  return new Date() <= expiresAt ? "OPEN" : "EXPIRED";
};

export function Tasks(props: any) {
  const [MoodMeterdisplayBasic, setMoodMeterDisplayBasic] = useState(false);
  const [moodMeterCheck, setMoodMeterCheck] = useState(false);
  const [ttecValuesCheck, setttecValuesCheck] = useState(false);
  const [showStatutoryModal, setShowStatutoryModal] = useState(false); // ← ADDED
  const { nonSSOlogout } = useContext(AuthContext);
  const dispatch = useDispatch();

  const dialogFuncMap = {
    MoodMeterdisplayBasic: setMoodMeterDisplayBasic,
  };
  const NhtpDisplay = useSelector(getNhtpLinkDetails);
  let intialStageId = useSelector(welcomeTask);
  if (intialStageId.length > 1) {
    intialStageId = intialStageId[0]
      ? intialStageId[0].automation_process_employee_uid
      : "";
  } else {
    intialStageId = intialStageId
      ? intialStageId.automation_process_employee_uid
      : "";
  }

  const clickedStageIdValue = props.clickedStageIdValue;
  const { profileData } = useSelector(empProfileDetails);

  const [oracleId, setOracleId] = useState("0");

  useEffect(() => {
    const SSOToken = localStorage.getItem("AccessToken");
    const nonSSOToken = localStorage.getItem("AccessToken-NonSSO");
    let id: any;

    //if (SSOToken && isTokenExpired(SSOToken)) {
    //  console.log("SSO Token Expired");
    //  logout();
    //}
    if (nonSSOToken && isTokenExpired(nonSSOToken)) {
      // console.log("Non SSO Token Expired");
      nonSSOlogout();
    }

    if (SSOToken) {
      id = localStorage.getItem("oracleId");
    }
    if (nonSSOToken) {
      const decodedToken: any = jwt_decode(nonSSOToken);
      id = decodedToken?.oracleID;
    }
    setOracleId(id);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [localStorage.getItem("oracleId")]);
  let firstName = profileData?.automation?.employee?.first_name;
  let lastName = profileData?.automation?.employee?.last_name;
  let latest_start_date = profileData?.automation?.employee?.latest_start_date;

  useEffect(() => {
    let requestdata;
    if (oracleId !== null && oracleId !== undefined && oracleId !== "0") {
      if (clickedStageIdValue === 0 || clickedStageIdValue === undefined) {
        requestdata = {
          action: "getTasks",
          processEmployeeId: intialStageId,
          oracleId: oracleId,
        };
      } else {
        requestdata = {
          action: "getTasks",
          processEmployeeId: clickedStageIdValue,
          oracleId: oracleId,
        };
      }
    }
    dispatch<any>(tasksList(requestdata));
  }, [dispatch, intialStageId, clickedStageIdValue, oracleId]);

  const listsdata = useSelector(tasksListDetails);
  const taskArray = Array.isArray(listsdata) ? listsdata : [listsdata];
  const [TTECPre, setTTECPre] = useState(false);
  const [TTECPre0, setTTECPre0] = useState(false);
  const [TTECPre5, setTTECPre5] = useState(false);

  const [TTECPree5, setTTECPree5] = useState(false);
  const [TTECPree15, setTTECPree15] = useState(false);
  const [TTECPree30, setTTECPree30] = useState(false);

  const handleCheckboxChangee5 = (event: any) => {
    setTTECPree5(event.target.checked);
  };
  const handleCheckboxChangee15 = (event: any) => {
    setTTECPree15(event.target.checked);
  };
  const handleCheckboxChangee30 = (event: any) => {
    setTTECPree30(event.target.checked);
  };

  const handleCheckboxChange = (event: any) => {
    setTTECPre(event.target.checked);
  };
  const handleCheckboxChange0 = (event: any) => {
    setTTECPre0(event.target.checked);
  };
  const handleCheckboxChange5 = (event: any) => {
    setTTECPre5(event.target.checked);
  };
  let [value, setValue] = useState(null);
  let [remarks, setRemarks] = useState("");
  const [happyRemarks, setHappyRemarks] = useState("");
  const [stepId, setStepId] = useState("");
  const [sName, setName] = useState(null);
  const [taskName, settaskName] = useState("");
  const isFirstRender = useRef(true);
  const toast = useRef<any>(null);

  const formattedDate = (): string => {
    if (sName === "TTEC_Pre-Employment_Requirements") {
      const startDate = new Date(taskArray[0].sched_date);
      const futureDate = new Date(startDate);
      futureDate.setDate(startDate.getDate() + 10);
      const options: Intl.DateTimeFormatOptions = {
        year: "numeric",
        month: "long",
        day: "numeric",
      };
      return futureDate.toLocaleDateString("en-US", options);
    } else if (sName === "TTEC_Pre-Employment_Requirements 0") {
      const startDate = new Date(taskArray[0].sched_date);
      const futureDate = new Date(startDate);
      futureDate.setDate(startDate.getDate() + 5);
      const options: Intl.DateTimeFormatOptions = {
        year: "numeric",
        month: "long",
        day: "numeric",
      };
      return futureDate.toLocaleDateString("en-US", options);
    }
    return "";
  };

  const formattedDatee = (): string => {
    if (sName === "Avoid_pay_issues_by_completing_your_BPI_survey 5") {
      const startDate = new Date(taskArray[0].sched_date);
      const futureDate = new Date(startDate);
      futureDate.setDate(startDate.getDate() + 25);
      const options: Intl.DateTimeFormatOptions = {
        year: "numeric",
        month: "long",
        day: "numeric",
      };
      return futureDate.toLocaleDateString("en-US", options);
    } else if (sName === "Avoid_pay_issues_by_completing_your_BPI_survey 15") {
      const startDate = new Date(taskArray[0].sched_date);
      const futureDate = new Date(startDate);
      futureDate.setDate(startDate.getDate() + 15);
      const options: Intl.DateTimeFormatOptions = {
        year: "numeric",
        month: "long",
        day: "numeric",
      };
      return futureDate.toLocaleDateString("en-US", options);
    }
    return "";
  };

  const onClick = (name: any, sid: any, sName: any, taskName: any) => {
    if (oracleId && firstName && lastName) {
      localStorage.setItem("oracleId", oracleId);
      localStorage.setItem("firstName", firstName);
      localStorage.setItem("lastName", lastName);
    }

    const keysToTransfer = ["oracleId", "firstName", "lastName"];

    if (oracleId !== null && oracleId !== undefined && oracleId !== "0") {
      if (sName === "Mood_Meter") {
        dialogFuncMap["MoodMeterdisplayBasic"](true);
        setStepId(sid);
        setName(sName);
        if (isFirstRender.current === true) {
          const requestdata = {
            action: "moodMeter",
            oracleId: oracleId,
            flag: "getTeamLeader",
            answer: "",
            id: "",
            feedbackVal: "",
          };
          isFirstRender.current = false;
          dispatch<any>(moodMeter(requestdata));
        }
      } else if (
        sName === "NHTP_1" ||
        sName === "NHTP_2" ||
        sName === "NHTP_3" ||
        sName === "Day_1 Readiness Survey_Equipment" ||
        sName === "Day_1 Readiness Survey_Training " ||
        sName === "Day_1 Readiness Survey_System" ||
        sName === "Training_Survey_Midpoint" ||
        sName === "Training_Survey_Endpoint"
      ) {
        dialogFuncMap["MoodMeterdisplayBasic"](true);
        setStepId(sid);
        setName(sName);
        settaskName(taskName);
        const requestdata = {
          action: "getNhtpLink",
          oracleId: oracleId,
          sched_step_uid: sid,
        };
        dispatch(Nhtp(requestdata));
      } else {
        dialogFuncMap["MoodMeterdisplayBasic"](true);
        setStepId(sid);
        setName(sName);
      }
    }
  };

  const onHide = (name: any) => {
    dialogFuncMap["MoodMeterdisplayBasic"](false);
    setValue(null);
    setTTECPre(false);
    setTTECPre0(false);
    setTTECPre5(false);
  };

  const employeeUid = profileData?.automation?.employee?.employee_uid;

  const dialogPopup = (rowData: any) => {
    // ← CHANGED: statutory now shows disabled style + modal, same as prod
    if (rowData?.step_name_uid === "Complete_Statutory_Requirements") {
      return (
        <span
          className="text-start text-muted"
          style={{ cursor: "pointer", opacity: 0.6, textDecoration: "underline" }}
          title="This application is not yet available."
          onClick={() => setShowStatutoryModal(true)}
        >
          {rowData?.task}
        </span>
      );
    }

    if (rowData.step_name_uid === "Onboarding_Digital_form") {
      return (
        <span
          className={
            rowData.STATUS === "Completed" || rowData.STATUS === "Not-Started"
              ? "text-start"
              : "anchorText text-start"
          }
          onClick={() => {
            if (rowData.STATUS !== "Completed" && rowData.STATUS !== "Not-Started") {
              localStorage.setItem("digitalFormStepId", rowData.automation_sched_step_uid);
              localStorage.setItem("digitalFormOracleId", oracleId);
              localStorage.setItem("digitalFormEmployeeUid", employeeUid);
              localStorage.setItem("digitalFormfullName", firstName + " " + lastName);
              window.location.href = "/digitalForm";
            }
          }}
        >
          {rowData?.task}
        </span>
      );
    }

    const isSurveyExpired =
      !!SURVEY_WINDOWS[rowData.step_name_uid] &&
      getSurveyEffectiveStatus(rowData) === "EXPIRED";

    return (
      <span
        className={
          rowData.STATUS === "Completed" ||
            rowData.STATUS === "Not-Started" ||
            isSurveyExpired
            ? "text-start"
            : "anchorText text-start"
        }
        style={isSurveyExpired ? { color: "#888888", cursor: "not-allowed" } : undefined}
        title={
          isSurveyExpired
            ? `Survey closed — ${SURVEY_WINDOWS[rowData.step_name_uid] === 120 ? "5 day" : "1 week"} window expired`
            : undefined
        }

        onClick={() =>
          rowData.STATUS === "Completed" ||
            rowData.STATUS === "Not-Started" ||
            isSurveyExpired
            ? ""
            : onClick(
              "MoodMeterdisplayBasic",
              rowData?.automation_sched_step_uid,
              rowData?.step_name_uid,
              rowData?.task
            )
        }
      >
        {rowData?.task}
      </span>
    );
  };

  const managerData = useSelector(managerListDetails);
  const { FAQData, moodMeterFAQState } = useSelector(faqListDetails);

  const [selectedFAQKeys, setSelectedFAQKeys] = useState<string[]>([]);
  const [faqRemarks, setFaqRemarks] = useState<{ [key: string]: string }>({});
  const [expandedIndexes, setExpandedIndexes] = useState<number[]>([]);

  const toggleFAQSelection = (index: number, confKey: string) => {
    setSelectedFAQKeys((prevKeys) =>
      prevKeys.includes(confKey)
        ? prevKeys.filter((key) => key !== confKey)
        : [...prevKeys, confKey]
    );
  };

  const updateTtecValues = (idS: any) => {
    const submit = {
      action: "ttecValues",
      flag: "updateTtecValues",
      oracleId: oracleId,
      id: idS.stepId,
    };
    dispatch<any>(tasksList(submit));
    dialogFuncMap["MoodMeterdisplayBasic"](false);
    setttecValuesCheck(true);
  };
  let ttecValuesData = [useSelector(tasksDetails)];
  const state = ["fulfilled", "failed"];
  if (ttecValuesCheck === true) {
    if (JSON.stringify(ttecValuesData[0]) === JSON.stringify(state[0])) {
      toast.current.show({
        severity: "success",
        summary: "Success Message",
        detail: "Successfully submitted",
        life: 3000,
      });
      window.location.reload();
    } else if (JSON.stringify(ttecValuesData[0]) === JSON.stringify(state[1])) {
      toast.current.show({
        severity: "error",
        summary: "error Message",
        detail: "Something went wrong while submiting",
        life: 3000,
      });
    }
  }
  const PreEmp = (idS: any) => {
    const submit = {
      action: "ttecValues",
      flag: "PreEmp",
      oracleId: oracleId,
      id: idS.stepId,
    };
    dispatch<any>(tasksList(submit));
    dialogFuncMap["MoodMeterdisplayBasic"](false);
    setttecValuesCheck(true);
  };
  const updatemoodMeter = (idS: any) => {
    if (oracleId && oracleId !== "0") {
      if (!value) {
        toast.current.show({
          severity: "error",
          summary: "Error Message",
          detail: "Please select any of the options",
          life: 3000,
        });
        return;
      }

      const isGoingWell = value === "It's going well so far";
      const isConcern = value === "I have concerns or need help";
      const hasFAQ = FAQData && FAQData.length > 0;

      if (isGoingWell) {
        const data = {
          action: "moodMeter",
          flag: "updateMoodMeter",
          oracleId,
          answer: value,
          id: idS.stepId,
          feedbackVal: happyRemarks?.trim() || "no-remarks",
        };
        dispatch<any>(moodMeter(data));
        dialogFuncMap["MoodMeterdisplayBasic"](false);
        resetForm();
        return;
      }

      if (isConcern) {
        if (hasFAQ && selectedFAQKeys.length === 0) {
          toast.current.show({
            severity: "error",
            summary: "Error Message",
            detail: "Please select at least one concern.",
            life: 3000,
          });
          return;
        }

        const hasEmptyFreeForm = FAQData.some((item: any) => {
          return (
            item.Display_type === "QnA_FreeFormText" &&
            selectedFAQKeys.includes(item.Conf_key) &&
            (!faqRemarks[item.Conf_key] ||
              faqRemarks[item.Conf_key].trim() === "")
          );
        });

        if (hasFAQ && hasEmptyFreeForm) {
          toast.current.show({
            severity: "error",
            summary: "Error Message",
            detail: "Please provide input for the selected concerns.",
            life: 3000,
          });
          return;
        }

        if (!hasFAQ && (!remarks || remarks.trim() === "")) {
          toast.current.show({
            severity: "error",
            summary: "Error Message",
            detail: "Please describe your concern.",
            life: 3000,
          });
          return;
        }
        const escapeHTML = (str: string) => {
          return str
            .replace(/&/g, "&amp;")
            .replace(/</g, "&lt;")
            .replace(/>/g, "&gt;")
            .replace(/"/g, "&quot;")
            .replace(/'/g, "&#39;");
        };

        const selectedFAQFeedback = hasFAQ
          ? selectedFAQKeys
            .map((key) => {
              const item = FAQData.find((faq: any) => faq.Conf_key === key);
              const question = item?.Question || key;
              const answer =
                item?.Display_type === "QnA_FreeFormText"
                  ? faqRemarks[key]?.trim()
                  : item?.Conf_value || "Selected";

              return `<strong>${escapeHTML(
                question
              )}</strong> <br/> ${escapeHTML(answer)}`;
            })
            .join("<br/>")
          : `${escapeHTML(remarks.trim())}`;
        const data = {
          action: "moodMeter",
          flag: "updateMoodMeter",
          oracleId,
          answer: value,
          id: idS.stepId,
          feedbackVal: selectedFAQFeedback || "no-remarks",
        };
        dispatch<any>(moodMeter(data));
        dialogFuncMap["MoodMeterdisplayBasic"](false);
        resetForm();
      }
    } else {
      toast.current.show({
        severity: "error",
        summary: "Error Message",
        detail: "Oracle ID is missing",
        life: 3000,
      });
    }
  };

  const resetForm = () => {
    setValue(null);
    setRemarks("");
    setHappyRemarks("");
    setMoodMeterCheck(true);
    setFaqRemarks({});
    setSelectedFAQKeys([]);
  };

  const submitAnonymously = (idS: any) => {
    if (oracleId && oracleId !== "0") {
      if (!value) {
        toast.current.show({
          severity: "error",
          summary: "Error Message",
          detail: "Please select any of the options",
          life: 3000,
        });
        return;
      }

      const isGoingWell = value === "It's going well so far";
      const isConcern = value === "I have concerns or need help";
      const hasFAQ = FAQData && FAQData.length > 0;

      if (isGoingWell) {
        const data = {
          action: "moodMeter",
          flag: "submitAnonymously",
          oracleId,
          answer: value,
          id: idS.stepId,
          feedbackVal: happyRemarks?.trim() || "no-remarks",
        };
        dispatch<any>(moodMeter(data));
        dialogFuncMap["MoodMeterdisplayBasic"](false);
        resetForm();
        return;
      }

      if (isConcern) {
        if (hasFAQ && selectedFAQKeys.length === 0) {
          toast.current.show({
            severity: "error",
            summary: "Error Message",
            detail: "Please select at least one concern.",
            life: 3000,
          });
          return;
        }

        const hasEmptyFreeForm = FAQData.some((item: any) => {
          return (
            item.Display_type === "QnA_FreeFormText" &&
            selectedFAQKeys.includes(item.Conf_key) &&
            (!faqRemarks[item.Conf_key] ||
              faqRemarks[item.Conf_key].trim() === "")
          );
        });

        if (hasFAQ && hasEmptyFreeForm) {
          toast.current.show({
            severity: "error",
            summary: "Error Message",
            detail: "Please provide input for the selected concerns.",
            life: 3000,
          });
          return;
        }

        if (!hasFAQ && (!remarks || remarks.trim() === "")) {
          toast.current.show({
            severity: "error",
            summary: "Error Message",
            detail: "Please describe your concern.",
            life: 3000,
          });
          return;
        }
        const escapeHTML = (str: string) => {
          return str
            .replace(/&/g, "&amp;")
            .replace(/</g, "&lt;")
            .replace(/>/g, "&gt;")
            .replace(/"/g, "&quot;")
            .replace(/'/g, "&#39;");
        };

        const selectedFAQFeedback = hasFAQ
          ? selectedFAQKeys
            .map((key) => {
              const item = FAQData.find((faq: any) => faq.Conf_key === key);
              const question = item?.Question || key;
              const answer =
                item?.Display_type === "QnA_FreeFormText"
                  ? faqRemarks[key]?.trim()
                  : item?.Conf_value || "Selected";

              return `<strong>${escapeHTML(
                question
              )}</strong> <br/> ${escapeHTML(answer)}`;
            })
            .join("<br/>")
          : `${escapeHTML(remarks.trim())}`;

        const data = {
          action: "moodMeter",
          flag: "submitAnonymously",
          oracleId,
          answer: value,
          id: idS.stepId,
          feedbackVal: selectedFAQFeedback || "no-remarks",
        };
        dispatch<any>(moodMeter(data));
        dialogFuncMap["MoodMeterdisplayBasic"](false);
        resetForm();
      }
    } else {
      toast.current.show({
        severity: "error",
        summary: "Error Message",
        detail: "Oracle ID is missing",
        life: 3000,
      });
    }
  };
  let countryName = profileData?.automation?.employee?.location_country;
  let jobFamily = profileData?.automation?.employee?.job_family;
  const [isSSOLogin, setisSSOLogin] = useState(false);
  useEffect(() => {
    const SSOToken = localStorage.getItem("AccessToken");
    const nonSSOToken = localStorage.getItem("AccessToken-NonSSO");
    let id: any;
    if (nonSSOToken && isTokenExpired(nonSSOToken)) {
      nonSSOlogout();
    }
    if (SSOToken) {
      id = localStorage.getItem("oracleId");
      setisSSOLogin(true);
    }
    if (nonSSOToken) {
      const decodedToken: any = jwt_decode(nonSSOToken);
      id = decodedToken?.oracleID;
    }
    setOracleId(id);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [localStorage.getItem("oracleId"), localStorage.getItem("email")]);

  let is_sso = "Pre-Hire";
  if (isSSOLogin) {
    is_sso = "Post-Hire";
  } else {
    is_sso = "Pre-Hire";
  }
  useEffect(() => {
    if (
      oracleId !== null &&
      oracleId !== undefined &&
      oracleId !== "0" &&
      countryName !== null &&
      countryName !== undefined &&
      countryName !== "" &&
      jobFamily !== null &&
      jobFamily !== undefined &&
      jobFamily !== ""
    ) {
      const requestData = {
        action: "getMoodmeterFAQs",
        oracleId: oracleId,
        country: countryName,
        is_sso: is_sso,
        jobFamily: jobFamily,
      };
      dispatch<any>(moodMeterFAQ(requestData));
    }
  }, [oracleId, countryName, jobFamily, is_sso, dispatch]);

  let moodMeterData = [useSelector(moodMeterDetails)];
  const states = ["fulfilled", "failed"];
  if (moodMeterCheck === true) {
    if (JSON.stringify(moodMeterData[0]) === JSON.stringify(states[0])) {
      toast.current.show({
        severity: "success",
        summary: "Success Message",
        detail: "Successfully submitted",
        life: 3000,
      });
      window.location.reload();
    } else if (JSON.stringify(moodMeterData[0]) === JSON.stringify(states[1])) {
      toast.current.show({
        severity: "error",
        summary: "error Message",
        detail: "Something went wrong while submiting",
        life: 3000,
      });
    }
  }
  const statusBodyTemplate = (rowData: any) => {
    return (
      <span className={`customer-badge status-${rowData?.STATUS}`}>
        {rowData?.STATUS}
      </span>
    );
  };
  const renderFooter = (name: any) => {
    if (sName === "View_TTEC_Values") {
      return (
        <div>
          <Button
            label="OK"
            aria-label="OK"
            className="float-end"
            onClick={() => updateTtecValues({ stepId })}
          />
        </div>
      );
    } else if (sName === "Mood_Meter") {
      return (
        <div className="d-flex">
          <Button
            label="Submit"
            aria-label="Submit"
            className="mt-3 d-inline-block"
            onClick={() => updatemoodMeter({ stepId })}
          />
          <Button
            label="Submit Anonymously"
            aria-label="Submit Anonymously"
            className="mt-3 ms-2 d-inline-block"
            onClick={() => submitAnonymously({ stepId })}
          />
        </div>
      );
    } else if (sName === "View_PC_Installation_Video") {
      return (
        <div>
          <Button
            label="OK"
            aria-label="OK"
            onClick={() => updateTtecValues({ stepId })}
          />
        </div>
      );
    } else if (sName === "TTECConnect_feedback_survey") {
      return (
        <div>
          <Button
            label="OK"
            aria-label="OK"
            className="float-end"
            onClick={() => updateTtecValues({ stepId })}
          />
        </div>
      );
    } else if (sName === "View_PC_Installation_Video_1") {
      return (
        <div>
          <Button
            label="OK"
            aria-label="OK"
            onClick={() => updateTtecValues({ stepId })}
          />
        </div>
      );
    } else if (sName === "View_PC_Installation_Video_2") {
      return (
        <div>
          <Button
            label="OK"
            aria-label="OK"
            onClick={() => updateTtecValues({ stepId })}
          />
        </div>
      );
    } else if (sName === "View_PC_Installation_Video_3") {
      return (
        <div>
          <Button
            label="OK"
            aria-label="OK"
            onClick={() => updateTtecValues({ stepId })}
          />
        </div>
      );
    } else if (sName === "View_Okta_Verification_Video") {
      return (
        <div>
          <Button
            label="OK"
            aria-label="OK"
            onClick={() => updateTtecValues({ stepId })}
          />
        </div>
      );
    } else if (sName === "View_Ping_ID_Set_Up_on_Mobile_Device_Video") {
      return (
        <div>
          <Button
            label="OK"
            aria-label="OK"
            onClick={() => updateTtecValues({ stepId })}
          />
        </div>
      );
    } else if (sName === "TTEC_Pre-Employment_Requirements 5") {
      return (
        <div>
          <Button
            label="Submit"
            aria-label="Submit"
            onClick={() => PreEmp({ stepId })}
            disabled={!TTECPre5}
          />
        </div>
      );
    } else if (sName === "TTEC_Pre-Employment_Requirements") {
      return (
        <div>
          <Button
            label="Submit"
            aria-label="Submit"
            onClick={() => PreEmp({ stepId })}
            disabled={!TTECPre}
          />
        </div>
      );
    } else if (sName === "TTEC_Pre-Employment_Requirements 0") {
      return (
        <div>
          <Button
            label="Submit"
            aria-label="Submit"
            onClick={() => PreEmp({ stepId })}
            disabled={!TTECPre0}
          />
        </div>
      );
    } else if (sName === "Avoid_pay_issues_by_completing_your_BPI_survey 5") {
      return (
        <div>
          <Button
            label="Submit"
            aria-label="Submit"
            className="float-end"
            onClick={() => PreEmp({ stepId })}
            disabled={!TTECPree5}
          />
        </div>
      );
    } else if (sName === "Avoid_pay_issues_by_completing_your_BPI_survey 15") {
      return (
        <div>
          <Button
            label="Submit"
            aria-label="Submit"
            className="float-end"
            onClick={() => PreEmp({ stepId })}
            disabled={!TTECPree15}
          />
        </div>
      );
    } else if (sName === "Avoid_pay_issues_by_completing_your_BPI_survey 30") {
      return (
        <div>
          <Button
            label="Submit"
            aria-label="Submit"
            className="float-end"
            onClick={() => PreEmp({ stepId })}
            disabled={!TTECPree30}
          />
        </div>
      );
    }
  };

  const onKeypress = (e: any, type: string) => {
    let keycode = e.which || e.keyCode;

    if (
      keycode !== 32 &&
      (keycode < 44 ||
        keycode === 45 ||
        keycode === 47 ||
        (keycode > 57 && keycode < 65) ||
        (keycode > 90 && keycode < 97) ||
        keycode > 122)
    ) {
      e.preventDefault();
      return false;
    } else {
      if (type === "remarks") {
        const sub = remarks + String.fromCharCode(keycode);
        setRemarks(sub);
      }
    }
  };

  const onPaste = (e: any) => {
    e.preventDefault();
  };

  // Utility function to calculate business days between two dates
  function getBusinessDays(startDate: Date, endDate: Date) {
    let count = 0;
    let currentDate = new Date(startDate);
    while (currentDate <= endDate) {
      const dayOfWeek = currentDate.getDay();
      if (dayOfWeek !== 0 && dayOfWeek !== 6) count++;
      currentDate.setDate(currentDate.getDate() + 1);
    }
    return count;
  }

  // Utility function to parse 'M/D/YYYY h:mm:ss AM/PM' format
  function parseUSDateTime(dateStr: string) {
    const [datePart, timePart, ampm] = dateStr.split(/\s+/);
    const [month, day, year] = datePart.split('/').map(Number);
    let [hour, minute, second] = timePart.split(':').map(Number);
    if (ampm === 'PM' && hour < 12) hour += 12;
    if (ampm === 'AM' && hour === 12) hour = 0;
    return new Date(year, month - 1, day, hour, minute, second);
  }

  const [isStatutoryLinkDisabled, setIsStatutoryLinkDisabled] = useState(false);
  useEffect(() => {
    if (latest_start_date) {
      console.log("Calculating statutory link disabled state...", latest_start_date);
      const startDate = parseUSDateTime(latest_start_date);
      const today = new Date();
      const businessDays = getBusinessDays(startDate, today);
      setIsStatutoryLinkDisabled(businessDays > 12);
    } else {
      setIsStatutoryLinkDisabled(false);
    }
  }, [latest_start_date]);
  console.log("isStatutoryLinkDisabled :", isStatutoryLinkDisabled);

  return (
    <>
      {/* ← ADDED: Statutory "not yet available" modal — same as prod */}
      <Dialog
        header="Note"
        visible={showStatutoryModal}
        style={{ width: "30vw" }}
        onHide={() => setShowStatutoryModal(false)}
        footer={
          <button className="btn btn-primary" onClick={() => setShowStatutoryModal(false)}>
            Close
          </button>
        }
      >
        <div style={{ fontSize: "1.1rem" }}>
          This application is not yet available. You can close the browser.
        </div>
      </Dialog>

      {sName === "Mood_Meter" ? (
        <>
          <Dialog
            header="Mood Meter - How are you doing"
            visible={MoodMeterdisplayBasic}
            style={{ width: "60vw" }}
            footer={renderFooter("displayMaximizable")}
            onHide={() => onHide("MoodMeterdisplayBasic")}
          >
            <div
              className="row"
              id="moodMeter"
              style={{ maxHeight: "400px", overflow: "auto" }}
            >
              <div className="col-12">
                <div className="card border-0">
                  <div className="card-body">
                    <p className="text-center">
                      <img
                        src="./images/57.png"
                        className="img-fluid imageMM"
                        alt="Mood Meter Question"
                      ></img>
                    </p>
                    <p className="card-text mt-5">
                      Hi <b>{managerData?.preferred_name}!</b>
                    </p>
                    <p className="card-text">
                      Your feedback is invaluable in helping us improve the new
                      hire onboarding experience.
                    </p>
                    <p className="card-text">
                      Please take a moment to answer the question below:
                    </p>
                    <div className="row mt-3">
                      <div className="col-12" id="moodMeterQuestions">
                        <p>How are you feeling about your experience so far?</p>
                        <div className="custom-control custom-radio">
                          <div className="field-radiobutton">
                            <RadioButton
                              value="It's going well so far"
                              inputId="moodMeterRadioBtn-1"
                              name="moodMeterRadio"
                              onChange={(e) => setValue(e.value)}
                              checked={value === "It's going well so far"}
                            />
                            <label
                              htmlFor="moodMeterRadioBtn-1"
                              className="text-start ms-3"
                            >
                              🙂 - It's going well so far
                            </label>
                          </div>
                          <div
                            className="float-left mt-4"
                            style={{
                              display:
                                value === "It's going well so far"
                                  ? "block"
                                  : "none",
                            }}
                          >
                            <InputTextarea
                              placeholder="Please provide your concerns...."
                              value={happyRemarks}
                              onChange={(e) => setHappyRemarks(e.target.value)}
                              rows={5}
                              cols={100}
                              onKeyPress={(event) =>
                                onKeypress(event, "subject")
                              }
                              onPaste={(event) => onPaste(event)}
                            />
                          </div>
                          <div className="field-radiobutton mt-sm-0 mt-3">
                            <RadioButton
                              value="I have concerns or need help"
                              inputId="moodMeterRadioBtn-2"
                              name="moodMeterRadio"
                              onChange={(e) => setValue(e.value)}
                              checked={value === "I have concerns or need help"}
                            />
                            <label
                              htmlFor="moodMeterRadioBtn-2"
                              className="text-start ms-3"
                            >
                              😟 - I have concerns or need help
                            </label>
                          </div>
                        </div>
                        <div
                          className="float-left mt-4"
                          style={{
                            display:
                              value === "I have concerns or need help"
                                ? "block"
                                : "none",
                          }}
                        >
                          {moodMeterFAQState === "fulfilled" &&
                            Array.isArray(FAQData) &&
                            FAQData.length > 0 ? (
                            <Accordion
                              multiple
                              activeIndex={expandedIndexes}
                              onTabChange={(e) =>
                                setExpandedIndexes(
                                  Array.isArray(e.index) ? e.index : [e.index]
                                )
                              }
                            >
                              {FAQData.map((item: any, index: number) => (
                                <AccordionTab
                                  key={item.Conf_key}
                                  header={
                                    <div className="d-flex align-items-center w-100">
                                      <span className="me-2 fw-bold">
                                        {item.Conf_key || "Untitled Question"}
                                      </span>
                                      <div className="ms-auto">
                                        <input
                                          type="checkbox"
                                          checked={selectedFAQKeys.includes(
                                            item.Conf_key
                                          )}
                                          onChange={() =>
                                            toggleFAQSelection(
                                              index,
                                              item.Conf_key
                                            )
                                          }
                                          onClick={(e) => e.stopPropagation()}
                                        />
                                      </div>
                                    </div>
                                  }
                                >
                                  <div className="mt-2">
                                    {item.Display_type === "QnA_HTML" ? (
                                      <div
                                        dangerouslySetInnerHTML={{
                                          __html: item.Conf_value,
                                        }}
                                      />
                                    ) : item.Display_type ===
                                      "QnA_FreeFormText" ? (
                                      <InputTextarea
                                        value={faqRemarks[item.Conf_key] || ""}
                                        onChange={(e) =>
                                          setFaqRemarks({
                                            ...faqRemarks,
                                            [item.Conf_key]: e.target.value,
                                          })
                                        }
                                        rows={5}
                                        cols={75}
                                        onKeyPress={(event) =>
                                          onKeypress(event, "subject")
                                        }
                                        onPaste={(event) => onPaste(event)}
                                        placeholder="Please describe your concern..."
                                      />
                                    ) : (
                                      <p>{item.Conf_value}</p>
                                    )}
                                  </div>
                                </AccordionTab>
                              ))}
                            </Accordion>
                          ) : (
                            <InputTextarea
                              placeholder="Please provide your concerns...."
                              value={remarks}
                              onChange={(e) => setRemarks(e.target.value)}
                              rows={5}
                              cols={100}
                              onKeyPress={(event) =>
                                onKeypress(event, "subject")
                              }
                              onPaste={(event) => onPaste(event)}
                            />
                          )}
                        </div>
                      </div>
                    </div>
                    <p className="mt-4">
                      Your answer will be sent to your Team Lead,{" "}
                      <b>unless if submitted anonymously</b>. If you have
                      concerns or challenges, you can always talk to your Team
                      Lead,{" "}
                      <b>
                        {managerData?.manager_firstname}{" "}
                        {managerData?.manager_lastname},{" "}
                        {managerData?.manager_email_work}
                      </b>
                      …in fact, I encourage it!
                    </p>
                    <p className="mt-4">Have a good rest of the day!</p>
                  </div>
                </div>
              </div>
            </div>
          </Dialog>
        </>
      ) : (
        ""
      )}
      {sName === "View_TTEC_Values" ? (
        <>
          <Dialog
            header="TTEC Values: Our Company Values"
            visible={MoodMeterdisplayBasic}
            style={{ width: "60vw" }}
            footer={renderFooter("displayMaximizable")}
            onHide={() => onHide("MoodMeterdisplayBasic")}
          >
            <div
              className="row"
              id="moodMeter"
              style={{ maxHeight: "400px", overflow: "auto" }}
            >
              <div className="col-12">
                <div className="card border-0">
                  <div className="card-body">
                    <p className="text-center">
                      <img
                        src="./images/TTEC_Values.png"
                        className="img-fluid imageMM"
                        alt="View TTEC Values"
                      ></img>
                    </p>{" "}
                    <p className="card-text mt-5">
                      At TTEC, we aspire to deliver experiences that are simple,
                      inspired and more human for both our clients and
                      employees. We do this, in part, by living our company
                      values.
                    </p>
                    <p className="card-text">
                      TTEC has six values that help us do business ethically
                      with our customers globally.
                    </p>
                    <p className="card-text">
                      Wondering what our values are? You'll discover them in the
                      next section.
                    </p>
                    <p className="card-text">
                      View TTEC Values{" "}
                      <a
                        href="https://spark.adobe.com/page/CDVb13EmoOJu4/"
                        target={"_blank"}
                        rel="noreferrer"
                      >
                        here
                      </a>
                      .
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </Dialog>
        </>
      ) : (
        ""
      )}
      {sName === "View_PC_Installation_Video" ? (
        <>
          <Dialog
            className="custom-dialog overflow-hidden"
            header="View PC Installation Video"
            visible={MoodMeterdisplayBasic}
            footer={renderFooter("displayMaximizable")}
            onHide={() => onHide("MoodMeterdisplayBasic")}
          >
            <iframe
              title="PC installation video"
              className="responsive-iframe"
              src="https://ttecvideos.wistia.com/medias/83hcx8he8o"
            ></iframe>
          </Dialog>
        </>
      ) : (
        ""
      )}
      {sName === "View_PC_Installation_Video_1" ? (
        <>
          <Dialog
            className="custom-dialog overflow-hidden"
            header="View PC Installation Video"
            visible={MoodMeterdisplayBasic}
            footer={renderFooter("displayMaximizable")}
            onHide={() => onHide("MoodMeterdisplayBasic")}
          >
            <iframe
              title="PC installation video"
              className="responsive-iframe"
              src="https://ttecvideos.wistia.com/medias/83hcx8he8o"
            ></iframe>
          </Dialog>
        </>
      ) : (
        ""
      )}
      {sName === "View_PC_Installation_Video_2" ? (
        <>
          <Dialog
            className="custom-dialog overflow-hidden"
            header="View PC Installation Video"
            visible={MoodMeterdisplayBasic}
            footer={renderFooter("displayMaximizable")}
            onHide={() => onHide("MoodMeterdisplayBasic")}
          >
            <iframe
              title="PC installation video"
              className="responsive-iframe"
              src="https://ttecvideos.wistia.com/medias/h6nbfz1fpk"
            ></iframe>
          </Dialog>
        </>
      ) : (
        ""
      )}
      {sName === "View_PC_Installation_Video_3" ? (
        <>
          <Dialog
            className="custom-dialog overflow-hidden"
            header="View PC Installation Video"
            visible={MoodMeterdisplayBasic}
            footer={renderFooter("displayMaximizable")}
            onHide={() => onHide("MoodMeterdisplayBasic")}
          >
            <iframe
              title="PC installation video"
              className="responsive-iframe"
              src="https://ttecvideos.wistia.com/medias/0h0opqreao"
            ></iframe>
          </Dialog>
        </>
      ) : (
        ""
      )}
      {sName === "View_Okta_Verification_Video" ? (
        <>
          <Dialog
            className="custom-dialog overflow-hidden"
            header="View Okta Verification Video"
            visible={MoodMeterdisplayBasic}
            footer={renderFooter("displayMaximizable")}
            onHide={() => onHide("MoodMeterdisplayBasic")}
          >
            <iframe
              title="PC installation video"
              className="responsive-iframe"
              src="https://ttecvideos.wistia.com/medias/1csqarq7bk"
            ></iframe>
          </Dialog>
        </>
      ) : (
        ""
      )}
      {sName === "View_Ping_ID_Set_Up_on_Mobile_Device_Video" ? (
        <>
          <Dialog
            className="custom-dialog overflow-hidden"
            header="View Ping ID Set Up on Mobile Device Video"
            visible={MoodMeterdisplayBasic}
            footer={renderFooter("displayMaximizable")}
            onHide={() => onHide("MoodMeterdisplayBasic")}
          >
            <iframe
              title="PC installation video"
              className="responsive-iframe"
              src="https://ttecvideos.wistia.com/medias/81avdf8vrb"
            ></iframe>
          </Dialog>
        </>
      ) : (
        ""
      )}

      {/* ← REMOVED: Complete_Statutory_Requirements dialog block (handled by showStatutoryModal above) */}

      {(sName === "NHTP_1" || sName === "NHTP_2" || sName === "NHTP_3") &&
        NhtpDisplay?.getNhtpState === "fulfilled" ? (
        <>
          <Dialog
            header={taskName}
            visible={MoodMeterdisplayBasic}
            style={{ width: "60vw" }}
            onHide={() => onHide("MoodMeterdisplayBasic")}
          >
            <div className="col-12">
              <div className="card border-0">
                <div className="card-body">
                  <div>{NhtpDisplay?.getNhtpData}</div>
                </div>
              </div>
            </div>
          </Dialog>
        </>
      ) : (
        ""
      )}

      {(sName === "Day_1 Readiness Survey_Equipment" ||
        sName === "Day_1 Readiness Survey_Training " ||
        sName === "Day_1 Readiness Survey_System") &&
        NhtpDisplay?.getNhtpState === "fulfilled" ? (
        <>
          <Dialog
            header={taskName}
            visible={MoodMeterdisplayBasic}
            style={{ width: "60vw" }}
            onHide={() => onHide("MoodMeterdisplayBasic")}
          >
            <div className="col-12">
              <div className="card border-0">
                <div className="card-body">
                  <div>{NhtpDisplay?.getNhtpData}</div>
                </div>
              </div>
            </div>
          </Dialog>
        </>
      ) : (
        ""
      )}

      {(sName === "Training_Survey_Midpoint" ||
        sName === "Training_Survey_Endpoint") &&
        NhtpDisplay?.getNhtpState === "fulfilled" ? (
        <>
          <Dialog
            header={taskName}
            visible={MoodMeterdisplayBasic}
            style={{ width: "60vw" }}
            onHide={() => onHide("MoodMeterdisplayBasic")}
          >
            <div className="col-12">
              <div className="card border-0">
                <div className="card-body">
                  <div>{NhtpDisplay?.getNhtpData}</div>
                </div>
              </div>
            </div>
          </Dialog>
        </>
      ) : (
        ""
      )}
      {sName === "TTEC_Pre-Employment_Requirements" ? (
        <>
          <Dialog
            header="Important: Submit your TTEC Pre-Employment Requirements!"
            visible={MoodMeterdisplayBasic}
            style={{ width: "60vw" }}
            footer={renderFooter("displayMaximizable")}
            onHide={() => onHide("MoodMeterdisplayBasic")}
          >
            <div
              className="row"
              id="moodMeter"
              style={{ maxHeight: "400px", overflow: "auto" }}
            >
              <div className="col-12">
                <div className="card-body">
                  <p className="card-text mt-3">
                    <strong>Important:</strong> Submit your TTEC Pre-Employment
                    Requirements!
                  </p>
                  <p className="card-text">
                    <strong>Urgent: </strong>
                    You only have 10 days to complete your TTEC Pre-Employment
                    Requirements. Please complete them by {formattedDate()}.
                    Click{" "}
                    <a
                      href="https://asknow.service-now.com/now/nav/ui/classic/params/target/%24viewer.do%3Fsysparm_stack%3Dno%26sysparm_sys_id%3D1176a1a14712b110bb82e54a436d43f7"
                      target={"_blank"}
                      rel="noreferrer"
                    >
                      Statutory Guide for New Hires
                    </a>{" "}
                    to get started!
                  </p>
                  <p className="card-text">
                    NOTE: Once you have completed the pre-employment
                    requirements, please <strong>revisit</strong> TTEC Connect and
                    provide your Acknowledgement included below.
                  </p>
                  <div>
                    <Checkbox
                      checked={TTECPre}
                      onChange={handleCheckboxChange}
                    />
                    <label style={{ width: "600px" }}>
                      I acknowledge that I have completed the TTEC
                      Pre-employment requirements.
                    </label>
                  </div>
                </div>
              </div>
            </div>
          </Dialog>
        </>
      ) : (
        ""
      )}
      {sName === "TTEC_Pre-Employment_Requirements 0" ? (
        <>
          <Dialog
            header="Urgent: You only have 5 days to complete your TTEC Pre-Employment Requirements!"
            visible={MoodMeterdisplayBasic}
            style={{ width: "60vw" }}
            footer={renderFooter("displayMaximizable")}
            onHide={() => onHide("MoodMeterdisplayBasic")}
          >
            <div
              className="row"
              id="moodMeter"
              style={{ maxHeight: "400px", overflow: "auto" }}
            >
              <div className="col-12">
                <div className="card-body">
                  <p className="card-text">
                    <strong>Urgent: </strong>
                    You only have 5 days to complete your TTEC Pre-Employment
                    Requirements. Please complete them by {formattedDate()}.
                    Click{" "}
                    <a
                      href="https://asknow.service-now.com/now/nav/ui/classic/params/target/%24viewer.do%3Fsysparm_stack%3Dno%26sysparm_sys_id%3D1176a1a14712b110bb82e54a436d43f7"
                      target={"_blank"}
                      rel="noreferrer"
                    >
                      Statutory Guide for New Hires
                    </a>{" "}
                    to get started!
                  </p>
                  <p className="card-text">
                    NOTE: Once you have completed the pre-employment
                    requirements, please <strong>revisit</strong> TTEConnect and
                    provide your Acknowledgement included below.
                  </p>
                  <div>
                    <Checkbox
                      checked={TTECPre0}
                      onChange={handleCheckboxChange0}
                    />
                    <label style={{ width: "600px" }}>
                      I acknowledge that I have completed the TTEC
                      Pre-employment requirements.
                    </label>
                  </div>
                </div>
              </div>
            </div>
          </Dialog>
        </>
      ) : (
        ""
      )}
      {sName === "TTEC_Pre-Employment_Requirements 5" ? (
        <>
          <Dialog
            header="Last day: Complete your TTEC Pre-Employment Requirements today!"
            visible={MoodMeterdisplayBasic}
            style={{ width: "60vw" }}
            footer={renderFooter("displayMaximizable")}
            onHide={() => onHide("MoodMeterdisplayBasic")}
          >
            <div
              className="row"
              id="moodMeter"
              style={{ maxHeight: "400px", overflow: "auto" }}
            >
              <div className="col-12">
                <div className="card-body">
                  <p className="card-text mt-3">
                    <strong>Last day:</strong> Complete your TTEC Pre-Employment
                    Requirements today!
                  </p>
                  <p className="card-text">
                    <strong>Urgent: </strong>
                    You must complete your TTEC Pre-Employment Requirements
                    today to avoid any escalations. Click{" "}
                    <a
                      href="https://asknow.service-now.com/now/nav/ui/classic/params/target/%24viewer.do%3Fsysparm_stack%3Dno%26sysparm_sys_id%3D1176a1a14712b110bb82e54a436d43f7"
                      target={"_blank"}
                      rel="noreferrer"
                    >
                      Statutory Guide for New Hires
                    </a>{" "}
                    to get started!
                  </p>
                  <p className="card-text">
                    NOTE: Once you have completed the pre-employment
                    requirements, please <strong>revisit</strong> TTEC Connect and
                    provide your Acknowledgement included below.
                  </p>
                  <div>
                    <Checkbox
                      checked={TTECPre5}
                      onChange={handleCheckboxChange5}
                    />
                    <label style={{ width: "600px" }}>
                      I acknowledge that I have completed the TTEC
                      Pre-employment requirements.
                    </label>
                  </div>
                </div>
              </div>
            </div>
          </Dialog>
        </>
      ) : (
        ""
      )}

      {sName === "Avoid_pay_issues_by_completing_your_BPI_survey 5" ? (
        <>
          <Dialog
            header="Important: Avoid pay issues by completing your BPI survey!"
            visible={MoodMeterdisplayBasic}
            style={{ width: "60vw" }}
            footer={renderFooter("displayMaximizable")}
            onHide={() => onHide("MoodMeterdisplayBasic")}
          >
            <div
              className="row"
              id="moodMeter"
              style={{ maxHeight: "400px", overflow: "auto" }}
            >
              <div className="col-12">
                <div className="card-body">
                  <p className="card-text mt-3">
                    <strong>Important:</strong> Avoid pay issues by completing
                    your BPI survey!
                  </p>
                  <p className="card-text mt-3">
                    <strong>Urgent:</strong> You only have 25 days to complete
                    your BPI account opening survey. Please complete them by{" "}
                    {formattedDatee()}. Click{" "}
                    <a
                      href="https://asknow.service-now.com/sys_attachment.do?sys_id=ef3ed9a1479e7110bb82e54a436d439f&view=true"
                      target={"_blank"}
                      rel="noreferrer"
                    >
                      BPI Payroll Account Opening FAQs
                    </a>{" "}
                    to get started!
                  </p>
                  <p className="card-text">
                    {" "}
                    NOTE: Once you have completed the BPI survey requirements,
                    please <strong>revisit</strong> TTEC SConnect and provide your
                    Acknowledgement included below.
                  </p>
                  <div>
                    <Checkbox
                      checked={TTECPree5}
                      onChange={handleCheckboxChangee5}
                    />
                    <label style={{ width: "600px" }}>
                      I acknowledge that I have completed the TTEC
                      Pre-employment requirements.
                    </label>
                  </div>
                </div>
              </div>
            </div>
          </Dialog>
        </>
      ) : (
        ""
      )}

      {sName === "Avoid_pay_issues_by_completing_your_BPI_survey 15" ? (
        <>
          <Dialog
            header="Urgent: You only have 5 days to complete your BPI account opening survey!"
            visible={MoodMeterdisplayBasic}
            style={{ width: "60vw" }}
            footer={renderFooter("displayMaximizable")}
            onHide={() => onHide("MoodMeterdisplayBasic")}
          >
            <div
              className="row"
              id="moodMeter"
              style={{ maxHeight: "400px", overflow: "auto" }}
            >
              <div className="col-12">
                <div className="card-body">
                  <p className="card-text mt-3">
                    <strong>Urgent:</strong> You only have 5 days to complete
                    your BPI account opening survey!. Please complete them by{" "}
                    {formattedDatee()}. Click{" "}
                    <a
                      href="https://asknow.service-now.com/sys_attachment.do?sys_id=ef3ed9a1479e7110bb82e54a436d439f&view=true"
                      target={"_blank"}
                      rel="noreferrer"
                    >
                      BPI Payroll Account Opening FAQs
                    </a>{" "}
                    to get started!
                  </p>
                  <p className="card-text">
                    {" "}
                    NOTE: Once you have completed the BPI survey requirements,
                    please <strong>revisit</strong> TTEConnect and provide your
                    Acknowledgement included below.
                  </p>
                  <div>
                    <Checkbox
                      checked={TTECPree15}
                      onChange={handleCheckboxChangee15}
                    />
                    <label style={{ width: "600px" }}>
                      I acknowledge that I have completed the TTEC
                      Pre-employment requirements.
                    </label>
                  </div>
                </div>
              </div>
            </div>
          </Dialog>
        </>
      ) : (
        ""
      )}

      {sName === "Avoid_pay_issues_by_completing_your_BPI_survey 30" ? (
        <>
          <Dialog
            header="Last day: Complete your BPI account opening survey today!"
            visible={MoodMeterdisplayBasic}
            style={{ width: "60vw" }}
            footer={renderFooter("displayMaximizable")}
            onHide={() => onHide("MoodMeterdisplayBasic")}
          >
            <div
              className="row"
              id="moodMeter"
              style={{ maxHeight: "400px", overflow: "auto" }}
            >
              <div className="col-12">
                <div className="card-body">
                  <p className="card-text mt-3">
                    <strong>Last day:</strong> Complete your BPI account opening
                    survey today!
                  </p>
                  <p className="card-text mt-3">
                    <strong>Urgent:</strong> You must complete your BPI account
                    opening survey requirements today to avoid any escalations.
                    Click{" "}
                    <a
                      href="https://asknow.service-now.com/sys_attachment.do?sys_id=ef3ed9a1479e7110bb82e54a436d439f&view=true"
                      target={"_blank"}
                      rel="noreferrer"
                    >
                      BPI Payroll Account Opening FAQs
                    </a>{" "}
                    to get started!
                  </p>
                  <p className="card-text">
                    {" "}
                    NOTE: Once you have completed the BPI survey requirements,
                    please <strong>revisit</strong> TTEC Connect and provide your
                    Acknowledgement included below."
                  </p>
                  <div>
                    <Checkbox
                      checked={TTECPree30}
                      onChange={handleCheckboxChangee30}
                    />
                    <label style={{ width: "600px" }}>
                      I acknowledge that I have completed the TTEC
                      Pre-employment requirements.
                    </label>
                  </div>
                </div>
              </div>
            </div>
          </Dialog>
        </>
      ) : (
        ""
      )}
      {sName === "TTECConnect_feedback_survey" ? (
        <>
          <Dialog
            header="TTEC Connect feedback survey"
            visible={MoodMeterdisplayBasic}
            footer={renderFooter("displayMaximizable")}
            onHide={() => onHide("MoodMeterdisplayBasic")}
          >
            <div
              className="row"
              id="moodMeter"
              style={{ maxHeight: "400px", overflow: "auto" }}
            >
              <div className="col-12">
                <div className="card-body">
                  <p>
                    <a
                      href="https://forms.office.com/Pages/ResponsePage.aspx?id=UJpcXVTIo06wXRY4ixTVs23typP1IGpPvyAswc-VKw9UMlFFNU44U005U1FNUUQ4M0xJRVdPUU5QVC4u"
                      target={"_blank"}
                      rel="noreferrer"
                    >
                      Click here to take the survey
                    </a>
                  </p>
                </div>
                <p>
                  Note: After completing the survey, please make sure to come
                  back and click on the OK button below.
                </p>
              </div>
            </div>
          </Dialog>
        </>
      ) : (
        ""
      )}

      <div className="col-md-9">
        <div className="card h-100 border rounded-0">
          <div className="card-body">
            <DataTable value={taskArray} responsiveLayout="scroll">
              <Column
                field="automation_sched_step_uid"
                header="Code"
                hidden
              ></Column>
              <Column field="task" header="Task" body={dialogPopup}></Column>
              <Column field="sched_date" header="Due Date"></Column>
              <Column
                field="STATUS"
                header="Status"
                body={statusBodyTemplate}
              ></Column>
            </DataTable>
          </div>
        </div>
      </div>

      <Toast ref={toast} />
    </>
  );
}